import {Directive, ElementRef, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[viewContainerRef]'
})
export class ViewContainerRefDirective {

  constructor(
    public elementRef: ElementRef,
    public viewContainerRef: ViewContainerRef,
  ) { }

}
